export const uniqueStringArray = (arr: string[]) => {
	const set = new Set();
	return arr.filter((item) => {
		const isDuplicate = set.has(item);
		set.add(item);
		return !isDuplicate;
	});
};

export const fileToDataUri = (file: File): Promise<string> =>
	new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = (event) => {
			resolve(event.target?.result as string);
		};
		reader.readAsDataURL(file);
	});
